import { useEffect, useState } from "react";
import { motion, useScroll } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { LogoMark } from "./Logo";
import { waLink, TEL_1 } from "./data";

const LINKS = [
    { label: "Collections", href: "#collections" },
    { label: "Why Us", href: "#why" },
    { label: "Visit Us", href: "#visit" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    const { scrollYProgress } = useScroll();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-nav"
            className={
                "fixed inset-x-0 top-0 z-50 transition-colors duration-500 " +
                (scrolled ? "glass-dark border-b border-gold/20" : "border-b border-transparent")
            }
        >
            <motion.div
                style={{ scaleX: scrollYProgress }}
                className="absolute inset-x-0 top-0 h-[2.5px] origin-left bg-gold"
                aria-hidden="true"
            />
            <div className="mx-auto flex h-[76px] max-w-7xl items-center justify-between px-5 sm:px-8">
                <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-3">
                    <LogoMark size={42} />
                    <span className="leading-tight">
                        <span className="block font-display text-[15px] font-bold tracking-[0.14em] text-cream">
                            BABA GARMENTS
                        </span>
                        <span className="block text-[9px] font-semibold uppercase tracking-[0.34em] text-gold">
                            Wholesale Specialists
                        </span>
                    </span>
                </a>

                <nav className="hidden items-center gap-9 md:flex" aria-label="Primary">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.href.slice(1)}`}
                            className="group relative text-[13px] font-medium uppercase tracking-[0.18em] text-cream/75 transition-colors duration-300 hover:text-gold"
                        >
                            {l.label}
                            <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-gold transition-all duration-300 group-hover:w-full" />
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <a
                        href={TEL_1}
                        data-testid="nav-call-link"
                        className="hidden h-11 w-11 items-center justify-center rounded-full border border-gold/30 text-gold transition-colors duration-300 hover:bg-gold/10 lg:flex"
                        aria-label="Call Baba Garments"
                    >
                        <Phone size={17} />
                    </a>
                    <a
                        href={waLink()}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="nav-whatsapp-button"
                        className="group flex items-center gap-2 rounded-full bg-gold px-5 py-2.5 text-[13px] font-bold uppercase tracking-[0.14em] text-maroon-950 shadow-[0_10px_36px_-10px_rgba(212,175,55,0.65)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-gold-light"
                    >
                        <MessageCircle size={16} className="transition-transform duration-300 group-hover:-rotate-12" />
                        <span className="hidden sm:inline">WhatsApp Us</span>
                        <span className="sm:hidden">WhatsApp</span>
                    </a>
                </div>
            </div>
        </header>
    );
}